/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateTenantRestrictionsOptions,
  UpdateTenantRestrictionsStatus200,
  UpdateTenantRestrictionsStatus400,
  UpdateTenantRestrictionsStatus500,
} from '../types/UpdateTenantRestrictions'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateTenantRestrictions } from '../clients/updateTenantRestrictions'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateTenantRestrictionsMutationKey = () =>
  [{ url: '/v1/tenants/:tenant_id/restrictions' }] as const

export function updateTenantRestrictionsMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateTenantRestrictionsMutationKey()
  return mutationOptions<
    UpdateTenantRestrictionsStatus200,
    ResponseErrorConfig<UpdateTenantRestrictionsStatus400 | UpdateTenantRestrictionsStatus500>,
    UpdateTenantRestrictionsOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateTenantRestrictions({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Update tenant restrictions by ID.
 * {@link /v1/tenants/:tenant_id/restrictions}
 */
export function useUpdateTenantRestrictions<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateTenantRestrictionsStatus200,
      ResponseErrorConfig<UpdateTenantRestrictionsStatus400 | UpdateTenantRestrictionsStatus500>,
      UpdateTenantRestrictionsOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateTenantRestrictionsMutationKey()

  const baseOptions = updateTenantRestrictionsMutationOptions(config) as UseMutationOptions<
    UpdateTenantRestrictionsStatus200,
    ResponseErrorConfig<UpdateTenantRestrictionsStatus400 | UpdateTenantRestrictionsStatus500>,
    UpdateTenantRestrictionsOptions,
    TContext
  >

  return useMutation<
    UpdateTenantRestrictionsStatus200,
    ResponseErrorConfig<UpdateTenantRestrictionsStatus400 | UpdateTenantRestrictionsStatus500>,
    UpdateTenantRestrictionsOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateTenantRestrictionsStatus200,
    ResponseErrorConfig<UpdateTenantRestrictionsStatus400 | UpdateTenantRestrictionsStatus500>,
    UpdateTenantRestrictionsOptions,
    TContext
  >
}
